/* eslint-disable prettier/prettier */
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import QueryString from 'qs';
import Axios from 'assets/remote/axios';
import {
    GET_USERS,
    DELETE_USER,
    UPDATE_USER,
    CREATE_USER,
} from '../actions';
import {
    setUsers,
    userError,
    userSuccess,
} from './actions';



function* errorHandler(error) {
    if ('response' in error) {
        if ('errors' in error?.response?.data) {
            const keys = Object.keys(error?.response?.data?.errors);
            // eslint-disable-next-line no-restricted-syntax
            for (const item of keys)
                yield put(userError(error?.response?.data?.errors[item][0]));
        } else {
            yield put(userError(error?.response?.data?.message));
        }
        // yield put(userError(''));
    } else {
        yield put(userError(error.message));
        // yield put(userError(''));
    }
}

export function* watchGetUsers() {
    // eslint-disable-next-line no-use-before-define
    yield takeLatest(GET_USERS, getUsers);
}

const getUsersAsync = async (filter) => {
    const r = await Axios.get('/users', {
        params: filter,
        paramsSerializer: (params) => {
            return QueryString.stringify(params, { arrayFormat: 'brackets', indices: false })
        }
    });
    return r?.data;
}

function* getUsers({ payload }) {
    const { filter } = payload;
    try {
        const response = yield call(getUsersAsync, filter);
        yield put(setUsers(response.users));
        // yield put(userSuccess('لیست با موفقیت دریافت شد'));
        yield put(userSuccess(''));
    } catch (error) {
        yield call(errorHandler, error);
    }
}



export function* watchDeleteUsers() {
    // eslint-disable-next-line no-use-before-define
    yield takeLatest(DELETE_USER, deleteUser);
}

const deleteUserAsync = async (id) => {
    const response = await Axios.delete(`/users/${id}`);
    return response?.data;
}

function* deleteUser({ payload }) {
    const { id, users } = payload;
    try {
        const result = yield call(deleteUserAsync, id);
        const { data } = users;
        const newData = data.filter(item => item.id !== id);
        const newUsers = { ...users, data: newData };
        yield put(setUsers(newUsers));
        yield put(userSuccess(result.message));
        yield put(userSuccess(''));
    } catch (error) {
        yield call(errorHandler, error);
    }
}
export function* watchUpdateUsers() {
    // eslint-disable-next-line no-use-before-define
    yield takeLatest(UPDATE_USER, updateUsers);
}

const updateUsersAsync = async (id, params) => {
    const response = await Axios.put(`/users/${id}`, params)
    return response?.data;
};

function* updateUsers({ payload }) {
    const { id, name,
        nationcode,
        mobile,
        // email,
        // sheba,
        role,
        limit,
        areas,
        users,
        filter, callbackSuccess } = payload;
    try {
        const result = yield call(updateUsersAsync, id, {
            name,
            nationcode,
            mobile,
            // email,
            // sheba,
            role,
            limit,
            areas
        })

        // const { data } = users;

        // const newItemIndex = data.findIndex((obj => obj.id === id));
        // data[newItemIndex].name = name;
        // data[newItemIndex].nationcode = nationcode;
        // data[newItemIndex].mobile = mobile;
        // data[newItemIndex].email = email;
        // data[newItemIndex].sheba = sheba;
        // data[newItemIndex].role = role;
        // data[newItemIndex].name = name;

        // const newUsers = { ...users, data };
        // yield put(setUsers(newUsers));
        yield call(callbackSuccess);
        yield call(getUsers, { payload: { filter } });
        yield put(userSuccess(result.message));
        yield put(userSuccess(''));
    } catch (error) {
        yield call(errorHandler, error);
    }
}

export function* watchCreateUsers() {
    // eslint-disable-next-line no-use-before-define
    yield takeLatest(CREATE_USER, createUsers);
}

const createUsersAsync = async (params) => {
    const resp = await Axios.post('/users', params);
    return resp?.data;
}

function* createUsers({ payload }) {
    const { name,
        nationcode,
        mobile,
        // email,
        // sheba,
        role, limit, areas, users, filter, callbackSuccess } = payload;
    try {
        const result = yield call(createUsersAsync, {
            name,
            nationcode,
            mobile,
            // email,
            // sheba,
            role,
            limit,
            areas
        });
        // users.push(result.subject);
        // yield put(setUsers(users));
        yield call(callbackSuccess);
        yield call(getUsers, { payload: { filter } });
        yield put(userSuccess(result.message));
        yield put(userSuccess(''));
    } catch (error) {
        yield call(errorHandler, error);
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchGetUsers),
        fork(watchDeleteUsers),
        fork(watchUpdateUsers),
        fork(watchCreateUsers),
    ]);
}
